import {
  useEffect, useRef 
} from "react";

export const useOnClickOutside = (ref, handler) => {
  const cheatRef = useRef({
    ref, handler 
  });

  cheatRef.current = {
    ref, handler 
  };

  useEffect(() => {
    const {
      ref, handler 
    } = cheatRef.current;

    const listener = event => {
      // Do nothing if clicking ref's element or descendent elements
      const refs = Array.isArray(ref) ? ref : [ref];

      let contains = false;

      refs.forEach(r => {
        if (!r.current || r.current.contains(event.target)) {
          contains = true;
                    
        }
      });

      // event.stopPropagation()
      if (!contains) {
        handler();
      }
    };

    document.addEventListener("mousedown", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
    };
  }, []);
};
